module.exports = __webpack_public_path__ + "img/IRR.a0df35c0.svg";